module.exports = __webpack_public_path__ + "img/banklogo-7.04e76f87.png";